// extracted by mini-css-extract-plugin
export default {"info":"ProfileOrders_info__de9Mo","body":"ProfileOrders_body__h4Saf"};